export default __webpack_public_path__ + "static/media/GR7 4A-1B-2D-4EC.b7ad0c53.jpg";